import { SimpleMasterPage } from "../common/SimpleMasterPage";
import { BiteCategoriesService } from "../../services";

export const BiteCategoriesPage = () => (
  <SimpleMasterPage
    title="Bite Categories"
    subtitle="DEVILLED, FRIED, GRILLED, etc."
    service={BiteCategoriesService}
    idKey="biteCategoryId"
    nameField="categoryName"
    nameLabel="Category name"
    testIdPrefix="bite-categories"
  />
);
